import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type WPDynamicPlacementProps = NodeProps<{
  content?: StructuredContent | StructuredContent[];
  id: number;
}>;

export function WPDynamicPlacement({ props }: WPDynamicPlacementProps) {
  if (!props.content) return null;

  return <StructuredContentRenderer doc={props.content} />;
}
